<script>

import { createEventDispatcher, onMount } from 'svelte';

const dispatch = createEventDispatcher();

export let filters;
export let maxCheckbox;

let location = '';
let filter = [];
let checked = [];

let filterCount = filters.length;

function locationUpdate(event) {    
    dispatch('search', {
        location: location,
        filter: filter
    });
}


onMount(async ()=> {
    if (filterCount > maxCheckbox) {
        const element = document.getElementById('filter');
        const choices = new Choices(element, {
            removeItemButton: true,
            placeholderValue:"select services",
            itemSelectText: 'Press to select',        
        });
        let listeners = ['change', 'blur'];
        for(let i = 0; i < listeners.length;i++) {
            choices.passedElement.element.addEventListener(listeners[i],
            (event) => {            
                var vals = element.parentElement.querySelectorAll('.choices__item.choices__item--selectable');
                filter = [];            
                for(let j = 0; j <vals.length; j++){
                    filter.push(vals[i].getAttribute("data-value"));
                } 
                locationUpdate();  
            }, false,);        
        } 
    }    
});


</script>

<svelte:head>
{#if filterCount > maxCheckbox}
<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/choices.js/public/assets/styles/choices.min.css" />
<script src="https://cdn.jsdelivr.net/npm/choices.js/public/assets/scripts/choices.min.js"></script>
{/if}
</svelte:head>

<style>
select,input[type='text']{
    max-width: 80%;
    min-width: 240px;
    /* margin: 0 auto; */
    display:block;
}
label {
    display: block;
    font-weight: bold;
}

.filters-checkboxes {
    display:grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: 20px;
    margin-left: 20px;
    margin-right: 20px;
}

h3 {
   margin:0;
   display:inline-block;
}
summary:focus{
 outline: 0;
}

.item {
    padding: 5px 20px 10px;    
}
</style>
<div class='item'>
    <h3><label for='location'>{window.mapinfo.translate.location}</label></h3>
    <input  data-category='filter_clinic' data-action='location' data-label={location}  type=text name='location' id='location' bind:value={location} on:change={locationUpdate} />
</div>

<div class='item'>    
    {#if filterCount > maxCheckbox}        
        <label class='filters-select' for='filter'>{window.mapinfo.translate.filters}
            <select multiple id='filter' >       
            {#each filters as choice }
                <option value={choice.value} >{@html choice.text}</option>
            {/each}
            </select>
        </label>
    {:else}
    <details>
        <summary><h3>{window.mapinfo.translate.filters}</h3></summary>
        <div class='filters-checkboxes'>
        {#each filters as choice ,i}
            <label class='filters-checkbox' for="services{i}" >
            <input data-category='filter_clinic' data-action='type_service' data-label={choice.text} type=checkbox id="services{i}" bind:checked={checked[i]} on:change on:change={locationUpdate} bind:group={filter} value={choice.value} />{@html choice.text}</label>
        {/each}
        </div>
    </details>
    {/if}
</div>


